<template>
  <Authenticated>
    <section v-for="site in siteMap" :key="site" class="main">
      <h2>{{ site.site }}</h2>
      <div class="unit-container">
        <div v-for="sat in site.stations.sat" :key="sat" class="unit" @click.stop.prevent="openSatModal(sat)">
          <h3>{{ sat.name }}</h3>
        </div>
        <div class="unit new" @click.stop.prevent="openSatModal(site.site, true)">Add Satellite station</div>
      </div>
      <button class="floorplan" @click.stop.prevent="$router.push(`/floorplan/${site.site}`)">Adjust floorplan for {{ site.site }}</button>
    </section>

    <SatelliteStationModal :open="showSatModal" :station="satStation" :newStation="newStation" @update="updateStations" @close="close" />
  </Authenticated>
</template>

<script>
import Authenticated from "../../_layouts/Authenticated.vue";
import SatelliteStationModal from "../Satellite/SatelliteStationModal.vue";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";

export default {
  name: "POSPage",
  components: {
    Authenticated,
    SatelliteStationModal,
  },
  data() {
    return {
      showSatModal: false,
      satStation: {},
      newStation: false,
    };
  },
  methods: {
    close() {
      this.showSatModal = false;
    },
    openSatModal(incoming, newStation = false) {
      this.satStation = {
        name: null,
        site: null,
      };
      this.newStation = newStation;
      if (newStation) {
        this.satStation.site = incoming;
        this.showSatModal = !this.showSatModal;
        return;
      }
      this.satStation = incoming;
      this.showSatModal = !this.showSatModal;
    },

    async updateStations(typeOfUpdate, typeOfStation, incomingStation) {
      let newStations = [];
      this.siteMap.forEach((site) => {
        if (site.site == incomingStation.site) {
          site.stations[typeOfStation].forEach((station) => {
            if (typeOfUpdate === "update") {
              if (station.name == incomingStation.name) {
                newStations.push(incomingStation);
              } else {
                newStations.push(station);
              }
            } else if (typeOfUpdate === "delete") {
              if (station.name != incomingStation.name) {
                newStations.push(station);
              }
            }
          });
        } else {
          site.stations[typeOfStation].forEach((station) => {
            newStations.push(station);
          });
        }
      });
      this.showKDSModal = false;
      this.showSatModal = false;

      await api.post("/api/company/update_stations", {
        doc: newStations,
        station_type: `get_${typeOfStation}`,
        site: incomingStation.site,
      });
      this.$store.dispatch("initialSiteMap");
    },
  },
  computed: {
    ...mapGetters({
      channels: "channels",
      siteMap: "siteMap",
      siteSettings: "siteSettings",
      companySettings: "companySettings",
      timezone: "timezone",
      sites: "sites",
    }),
  },
  mounted() {
    // Lifecycle hook when the component is mounted
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";
.header {
  margin: 1.5rem;
}
.main {
  padding: 1rem;
  box-shadow: var(--box-shadow);
  background-color: var(--primary-colour);
  margin: 2rem;
  border-radius: 10px;
  max-width: 90%;
  h2 {
    text-transform: capitalize;
  }
  .floorplan {
    background-color: var(--secondary-colour);
    color: var(--text-colour);
    border: none;
    border-radius: 10px;
    padding: 1rem;
    margin: 0.5rem 1.5rem;
    box-shadow: var(--box-shadow);
    text-transform: capitalize;
    cursor: pointer;
  }
  .unit-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    // background-color: var(--primary-colour);
    border-radius: 20px;
    margin: 1rem;
    .new {
      background-color: var(--action-colour) !important;
      color: var(--secondary-text-colour);
      border-radius: 1rem;
      padding: 1rem;
      margin: 0.5rem;
      box-shadow: var(--box-shadow);
      cursor: pointer;
      height: 25%;
      min-width: 16rem;
      text-align: center;
    }
    .unit {
      max-width: 95%;
      margin: 0.5rem;
      padding: 1rem;
      box-shadow: var(--box-shadow);
      border-radius: 10px;
      background-color: var(--secondary-colour);
      cursor: pointer;

      h3 {
        text-transform: capitalize;
        margin: 0.25rem 0;
      }
      p {
        color: var(--action-colour);
      }
      button {
        position: relative;
        bottom: 1rem;
        float: right;
        margin: 0.25rem;
        padding: 0.5rem;
        background-color: var(--action-colour);
        color: var(--primary-colour);
        font-size: smaller;
        box-shadow: var(--box-shadow);
        &:active {
          box-shadow: none;
          translate: transform3d(0, 0, 0);
        }
      }
      &:active {
        box-shadow: none;
        translate: transform3d(0, 0, 0);
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .main {
    padding: 0.5rem 0;
    margin: 1rem 0;
    border-radius: 0;
    max-width: 100%;
    .unit-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
